<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formInventoryEntry">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteInventoryEntry()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewInventoryEntry()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="inventoryEntryContract.userNameCreate"
                [createDate]="inventoryEntryContract.createDate"
                [userNameUpdate]="inventoryEntryContract.userNameUpdate"
                [updateDate]="inventoryEntryContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <!-- Formulario Captura -->
          <div class="row d-flex justify-content-between">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 pe-lg-5 pe-md-2">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventories"
                    [required]="true" [recovery]="true"
                    (onChangeSelect)="getInventory($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-3 col-6">
                  <app-custom-select formControlName="inventoryEntryTypeId" [labelText]="'Tipo Entrada'"
                    [list]="listTypes" [required]="true" [recovery]="true"
                    (onChangeSelect)="this.inventoryEntryTypeId = $event; changeSelection()"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-4 col-md-9 col-sm-6 col-12">
                  <app-custom-select formControlName="conceptId" [labelText]="'Concepto'" [list]="listConcepts"
                    [required]="true" (onChangeSelect)="getConcept($event)"></app-custom-select>
                </div>
                <div class="col-lg-5 col-md-8 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProviders"
                    [required]="true" (onChangeSelect)="getProvider($event)"></app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateEntry" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 ps-lg-5 ps-md-2 pt-lg-0 pt-sm-2">
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-2 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-1 col-6 d-flex align-items-end justify-content-center">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                </div>
                <div *ngIf="swPurchaseModule"
                  class="col-lg-4 col-md-5 col-sm-3 col-12 checkbox-container d-flex align-items-center mt-3">
                  <app-custom-checkbox formControlName="swRequirePurchaseOrder"
                    [labelText]="'Req.Ord. Compra'"></app-custom-checkbox>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-3 col-6">
                  <app-custom-input-text formControlName="remission" [labelText]="'Remisión'" [maxLength]="15">
                  </app-custom-input-text>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-3 col-6">
                  <app-custom-input-text formControlName="invoice" [labelText]="'Factura'" [maxLength]="15">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-10 col-md-12 col-sm-12 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false" [maxLength]="250"></app-custom-textarea>
                </div>
                <div
                  class="col-lg-2 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2  mt-2">
                  <app-custom-button [disabled]="disabledForm" [label]="'Guardar'" [severity]="'primary'"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-inventory-entry-detail [disabledDetail]="disabledDetail" [inventoryEntryModel]="inventoryEntryContract"
      [quantityDetails]="quantityDetails" [disabledActions]="disabledActions"
      [permissionUpdatable]="permissionUpdatable" [permissionsUser]="permissionsUser"
      [userAuthenticated]="userAuthenticated" (emitQuantityDetails)="quantityDetails = $event">
    </app-inventory-entry-detail>
  </div>
</section>
<app-print-inventory-entry id="print-inventory-entry" [companyId]="companyId" [formatModel]="formatModel"
  [inventoryEntryModel]="inventoryEntryPrintModel" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-inventory-entry>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>
    No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.
  </h6>
</div>